function tfgSetLineItemProperty(formData, key, value) {
  if (!formData || !key || value === undefined || value === null) return;

  const normalizedValue = String(value).trim();
  if (!normalizedValue) return;

  formData.set(`properties[${key}]`, normalizedValue.slice(0, 255));
}

function tfgGetPdpUpsellSourceHandle() {
  try {
    const sourceHandle = new URLSearchParams(window.location.search).get('pdp_src');
    if (!sourceHandle || !/^[a-z0-9][a-z0-9-]*$/i.test(sourceHandle)) return '';
    return sourceHandle;
  } catch (error) {
    return '';
  }
}

function tfgGetPdpUpsellSourceTitle(sourceHandle) {
  if (!sourceHandle) return '';

  const cards = document.querySelectorAll('[data-pdp-product-option-card]');
  for (const card of cards) {
    if (card.getAttribute('data-product-handle') === sourceHandle) {
      return card.getAttribute('data-product-title') || '';
    }
  }

  const options = document.querySelector('[data-pdp-product-options]');
  return options?.getAttribute('data-pdp-product-source-title') || '';
}

window.tfgApplyUpsellTrackingProperties = function (formData, form, productForm) {
  const formElement = productForm || form?.closest('product-form');
  if (!formData || !formElement) return formData;

  const targetHandle = formElement.dataset.productHandle || '';
  const targetTitle = formElement.dataset.productTitle || '';

  if (formElement.dataset.cartUpsell === 'true') {
    tfgSetLineItemProperty(formData, '_cart_upsell', 'true');
    tfgSetLineItemProperty(formData, '_cart_upsell_type', formElement.dataset.cartUpsellType);
    tfgSetLineItemProperty(formData, '_cart_upsell_source_handle', formElement.dataset.cartUpsellSourceHandle);
    tfgSetLineItemProperty(formData, '_cart_upsell_source_title', formElement.dataset.cartUpsellSourceTitle);
    tfgSetLineItemProperty(formData, '_cart_upsell_target_handle', targetHandle);
    tfgSetLineItemProperty(formData, '_cart_upsell_target_title', targetTitle);
    return formData;
  }

  const pdpSourceHandle = tfgGetPdpUpsellSourceHandle();
  if (pdpSourceHandle && targetHandle && pdpSourceHandle !== targetHandle) {
    tfgSetLineItemProperty(formData, '_pdp_upsell', 'true');
    tfgSetLineItemProperty(formData, '_pdp_upsell_source_handle', pdpSourceHandle);
    tfgSetLineItemProperty(formData, '_pdp_upsell_source_title', tfgGetPdpUpsellSourceTitle(pdpSourceHandle));
    tfgSetLineItemProperty(formData, '_pdp_upsell_target_handle', targetHandle);
    tfgSetLineItemProperty(formData, '_pdp_upsell_target_title', targetTitle);
  }

  return formData;
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.cart = this.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        window.tfgApplyUpsellTrackingProperties?.(formData, this.form, this);

        this.submitCartRequest(formData, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            return this.ensureCartRenderState(response).then((cartData) => {
              if (!cartData?.sections) {
                console.error('Cart drawer sections were not returned for add-to-cart.');
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: cartData,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(cartData);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(cartData);
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getLineProperties(item) {
        return item.properties && typeof item.properties === 'object' ? item.properties : {};
      }

      hasOnlyHiddenProperties(item) {
        return Object.keys(this.getLineProperties(item)).every((key) => key.charAt(0) === '_');
      }

      getSellingPlanKey(item) {
        return item.selling_plan_allocation?.selling_plan?.id || '';
      }

      getRequestedQuantity(formData) {
        const quantity = parseInt(formData.get('quantity') || '1', 10);
        return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
      }

      getRequestedSellingPlanKey(formData) {
        return formData.get('selling_plan') || '';
      }

      getSectionIds() {
        return this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
      }

      getExistingCart() {
        if (
          typeof routes.cart_url === 'undefined'
        ) {
          return Promise.resolve(null);
        }

        return fetch(`${routes.cart_url}.js`, { credentials: 'same-origin', cache: 'no-store' })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
            return null;
          });
      }

      getCartSections() {
        if (!this.cart || typeof routes.cart_url === 'undefined') return Promise.resolve(null);

        const sections = this.getSectionIds().join(',');
        const sectionUrl = `${routes.cart_url}?sections=${encodeURIComponent(sections)}&sections_url=${encodeURIComponent(window.location.pathname)}`;

        return fetch(sectionUrl, { credentials: 'same-origin', cache: 'no-store' })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
            return null;
          });
      }

      ensureCartRenderState(cartData) {
        if (cartData?.sections) return Promise.resolve(cartData);

        return this.getCartSections().then((sections) => {
          if (!sections) return cartData;
          return Object.assign({}, cartData, { sections });
        });
      }

      isMergeableCartItem(item, variantId, sellingPlanKey) {
        return (
          item?.variant_id === variantId &&
          this.getSellingPlanKey(item) === sellingPlanKey &&
          this.hasOnlyHiddenProperties(item)
        );
      }

      submitCartRequest(formData, config) {
        if (!this.cart || typeof routes.cart_change_url === 'undefined') {
          return fetch(`${routes.cart_add_url}`, config);
        }

        const variantId = parseInt(formData.get('id'), 10);
        if (!variantId) return fetch(`${routes.cart_add_url}`, config);

        return this.getExistingCart().then((cartData) => {
          const items = Array.isArray(cartData?.items) ? cartData.items : [];
          const sellingPlanKey = this.getRequestedSellingPlanKey(formData);
          const matchingItems = items
            .map((item, index) => ({ ...item, line: index + 1 }))
            .filter((item) => this.isMergeableCartItem(item, variantId, sellingPlanKey));

          if (!matchingItems.length) return fetch(`${routes.cart_add_url}`, config);

          const requestedQuantity = this.getRequestedQuantity(formData);
          const totalQuantity =
            matchingItems.reduce((sum, item) => sum + item.quantity, 0) + requestedQuantity;
          const keeper = matchingItems[0];
          const operations = [{ line: keeper.line, quantity: totalQuantity }].concat(
            matchingItems
              .slice(1)
              .sort((a, b) => b.line - a.line)
              .map((item) => ({ line: item.line, quantity: 0 }))
          );

          return this.runCartChangeOperations(operations);
        });
      }

      runCartChangeOperations(operations) {
        return operations.reduce((promise, operation) => {
          return promise.then(() => {
            const body = JSON.stringify({
              line: operation.line,
              quantity: operation.quantity,
              sections: this.getSectionIds(),
              sections_url: window.location.pathname,
            });

            return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body });
          });
        }, Promise.resolve());
      }

      normalizeDuplicateVariantLines(addResponse) {
        return this.mergeDuplicateVariantLines(null, addResponse);
      }

      mergeDuplicateVariantLines(cartData, addResponse) {
        if (!this.cart || typeof routes.cart_change_url === 'undefined') return Promise.resolve(addResponse);

        const variantId = parseInt(addResponse?.variant_id || addResponse?.id, 10);
        if (!variantId) return Promise.resolve(addResponse);

        const resolveCartData = Array.isArray(cartData?.items) ? Promise.resolve(cartData) : this.getExistingCart();

        return resolveCartData.then((currentCart) => {
          const items = Array.isArray(currentCart?.items) ? currentCart.items : [];
          const matchingItems = items
            .map((item, index) => ({ ...item, line: index + 1 }))
            .filter((item) => item.variant_id === variantId && this.hasOnlyHiddenProperties(item));

          if (matchingItems.length < 2) return Promise.resolve(addResponse);

          const keeper = matchingItems[0];
          const totalQuantity = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
          const operations = [{ line: keeper.line, quantity: totalQuantity }].concat(
            matchingItems
              .slice(1)
              .sort((a, b) => b.line - a.line)
              .map((item) => ({ line: item.line, quantity: 0 }))
          );

          return this.runCartChangeOperations(operations)
            .then((response) => response.json())
            .catch((error) => {
              console.error(error);
              return addResponse;
            });
        });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          else this.submitButtonText.textContent = this.submitButton.dataset.soldOutText || window.variantStrings.soldOut;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = this.submitButton.dataset.availableText || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
